"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchBulkAction = void 0;
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const FunctionClient_1 = require("@juvare/platform-sdk-js/FunctionClient");
const StorageClient_1 = require("@juvare/platform-sdk-js/StorageClient");
const shared_1 = require("../../../backend/features/bulk-actions/shared");
const react_1 = __importDefault(require("react"));
const BulkActionDialog_1 = require("./components/BulkActionDialog");
function launchBulkAction(params) {
    const storageClient = new StorageClient_1.StorageClient(shared_1.bulkActionEntityName, params.baseUrl, params.tokenProvider);
    const functionClient = new FunctionClient_1.FunctionClient(params.baseUrl, params.tokenProvider);
    const functionResponsePromise = functionClient.executeFunction({
        functionName: params.runSync ? shared_1.runBulkActionSyncFunctionName : shared_1.createBulkActionFunctionName,
        params: {
            type: params.type,
            params: params.params,
        },
    });
    if (params.runSync) {
        (0, DialogHelper_1.showProgressDialog)({
            title: params.title,
            callback: (done) => {
                functionResponsePromise
                    .then(({ result }) => {
                    var _a;
                    done();
                    (_a = params.onClose) === null || _a === void 0 ? void 0 : _a.call(params, result);
                })
                    .catch((error) => {
                    done();
                    (0, DialogHelper_1.handleErrorDialog)(error);
                });
            },
        });
    }
    else {
        (0, DialogHelper_1.showCustomDialog)({
            content: (close, ariaLabelledBy, ariaDescribedBy) => (react_1.default.createElement(BulkActionDialog_1.BulkActionDialog, { storageClient: storageClient, functionClient: functionClient, functionResponsePromise: functionResponsePromise, params: params, onClose: (result) => {
                    var _a;
                    close();
                    (_a = params.onClose) === null || _a === void 0 ? void 0 : _a.call(params, result);
                }, ariaLabelledById: ariaLabelledBy, ariaDescribedById: ariaDescribedBy })),
        });
    }
}
exports.launchBulkAction = launchBulkAction;
